'use client';

import React from 'react';
import { DeviceProvider } from '@mentimeter/ragnar-device';
import { breakpoints } from './breakpoints';

export const ContentDeviceProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => <DeviceProvider breakpoints={breakpoints}>{children}</DeviceProvider>;
